module.exports = __webpack_public_path__ + "media/images/icons/outlined/message-5b9129fddd04f99fe844c241c15c232f.svg";